import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import {ALPHA_NUMERIC_REGEX} from "../../plugins/vee-validate";
import {store} from './../../plugins/vuex/index'

export default class ConditionReportsModel extends BaseModel {
  uuid = null;
  inventory_uuid = null;
  title = null;
  body = null;
  internal_note = null;
  version = null;
  version_suffix = null;
  publish_on_website = false;
  status = 'draft';
  send_to_all = false;

  activeTab = 0;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    inventory_uuid: 'required',
    title: 'required',
    body: 'required',
  };

  attributeLabels = {
    uuid: i18n.t('Sale'),
    inventory_uuid: i18n.t('Inventory'),
    title: i18n.t('Title'),
    body: i18n.t('Body'),
    internal_note: i18n.t('Internal Note'),
    version: i18n.t('Version'),
    version_suffix: i18n.t('Version Suffix'),
    publish_on_website: i18n.t('Publish on Website'),
    status: i18n.t('Status'),
    send_to_all: i18n.t('Send to All users'),
  };

  attributeHints = {
    send_to_all: i18n.t('This checkbox will send this condition report to all users who requested condition report on this particular item.')
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    this.initTranslatableFields(this);
  }

  isReleased(){
    return this.status === 'released'
  }

  isDraft() {
    return this.status === 'draft'
  }

  toJSON() {
    return {
      uuid: this.uuid,
      inventory_uuid: this.inventory_uuid,
      title: this.title,
      body: this.body,
      internal_note: this.internal_note,
      version: this.version,
      version_suffix: this.version_suffix,
      publish_on_website: this.publish_on_website,
      status: this.status,
      send_to_all: this.send_to_all,
    }
  }
}

defineTranslatableProperties(ConditionReportsModel);
